import { render, staticRenderFns } from "./DealCardComponent.vue?vue&type=template&id=d5a41dec&scoped=true&"
import script from "./DealCardComponent.vue?vue&type=script&lang=js&"
export * from "./DealCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./DealCardComponent.vue?vue&type=style&index=0&id=d5a41dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a41dec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealPrice: require('/app/appsumo/nuxt/components/common/DealPrice.vue').default})
